import { render } from "./PointInfo.vue?vue&type=template&id=0b3deb91&scoped=true"
import script from "./PointInfo.vue?vue&type=script&lang=js"
export * from "./PointInfo.vue?vue&type=script&lang=js"

import "./PointInfo.vue?vue&type=style&index=0&id=0b3deb91&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3deb91"]])

export default __exports__